import React from "react";
import PaymentHealth from "../../features/payment-health/PaymentHealth";

export default function PaymentHealthPage() {
  return (
    <div>
      <PaymentHealth />
    </div>
  );
}
